<!-- 订单分发器，用于他人代付时根据orderId读取订单数据，直接拉起支付 -->
<script>
import config from '@/config/config'
import browserCheck from '@/utils/checkBrowser'
import { payOrder } from '@/api/order'

export default {
  created() {
    let { order_id: orderId } = this.$route.query
    // 处理支付回调
    if (this.$route.query.payResult) {
      this.onPayBack()
      return
    }
    if (!orderId) {
      location.href = `${config.siteRoot}/buyvip`
    }
    // 判断浏览器环境，拉起支付
    let payway = browserCheck.isAlipay ? 'alipay' : 'wechatpay'
    this.doPay(orderId, payway)
  },
  methods: {
    async doPay(orderId, payway) {
      this.$daidiLoading.show({
        text: '支付中，请稍候...',
      })
      // 超时错误
      let passTimer = setTimeout(() => {
        this.$daidiLoading.hide()
        this.$toast.show({
          text: '支付超时，请稍候再试'
        })
      }, 15000)
      try {
        let payInfo = await payOrder(orderId, payway, location.href, 'third')
        if (payInfo) window.location.href = payInfo.payUrl
      } catch (e) {
        console.log(e)
        if (e && e.retcode) {
          this.$daidiLoading.hide()
          clearTimeout(passTimer)
          switch (e.retcode) {
            case -1:
              this.$toast.show({
                text: '该订单不可支付',
                duration: 5000
              })
              break
            case -2:
              this.$toast.show({
                text: '该订单已关闭',
                duration: 5000
              })
              break
            case -3:
              this.$toast.show({
                text: '该订单已被支付',
                duration: 5000
              })
              break
            default:
              this.$toast.show({
                text: '订单信息异常，请稍后再试',
                duration: 5000
              })
          }
        } 
      }
    },
    // 处理支付回调
    onPayBack() {
      let payResult = this.$route.query.payResult // 支付结果，不是订单结果
      let orderId = this.$route.query.tradeNo // 订单号
      switch (payResult) {
        case 'cancel':
          break
        case 'fail':
          this.$toast.show({
            text: '支付失败，请重试',
            duration: 3000
          })
          break
        case 'ok':
          setTimeout(() => {
            this.$store.dispatch('updateUserinfo', this.$store.getters.token)
          }, 2000)
          // 跳出
          this.goPayResult()
          break
        default:
          this.$toast.show({
            text: '未知错误，请确认订单信息',
            duration: 3000
          })
      }
      // return this.goPayResult()
    },
    // 跳转到vip购买页
    goPayResult() {
      let { order_id: orderId } = this.$route.query
      location.href = `${config.siteRoot}/thirdpayresult?order_id=${orderId}`
    }
  },
  render: function(h) {
    return h() // avoid warning message
  }
}
</script>
